import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

const uploadHandlerApi = createApi({
    reducerPath: 'uploadHandler',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        uploadTeamLogo: builder.mutation<{ err: string; logo_url: string }, { logo: File }>({
            query: (data) => {
                const formData = new FormData();
                formData.append('file', data.logo);

                return {
                    method: 'POST',
                    url: '/upload_handler?type=team_logo',
                    body: formData,
                    headers: {
                        'x-auto-content-type': '1',
                    },
                };
            },
        }),
    }),
});

export default uploadHandlerApi;

export const { useUploadTeamLogoMutation } = uploadHandlerApi;
